import { ToastService } from './../../../../../core/toast.service';
import { AbstractControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-file-upload',
  templateUrl: './single-file-upload.component.html',
  styleUrls: ['./single-file-upload.component.scss']
})
export class SingleFileUploadComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  file: File;
  @Input()
  type: string; // IMAGE, VIDEO, FILE

  @Input()
  allowedTypes : string[]

  @Input()
  fileInput: AbstractControl;
/* ------------------------------- constructor ------------------------------ */

  constructor(
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }


  setFiles(fileList: FileList){
    console.log(fileList);
    const file = fileList.item(0);
    if(this.allowedTypes && this.allowedTypes.findIndex(single=>{
      return file.name.includes(single);
    }) === -1){
      this.toast.openSnackBar("This type of file not allowed");
      return;
    }
    if(this.file) {
      this.file = undefined;
      setTimeout(()=>{
        this.file  = file;
      }, 100);
    } else {
      this.file  = file;
    }
  }

  addFile(ev: any){
      this.fileInput.setValue(ev);
  }

  removeUrl(){
    this.fileInput.setValue(null);
  }

}

